import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Chip from "@mui/material/Chip";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function ServiceDetailDialog({ open, onClose, layanan, syarat, loadingSyarat }) {
  if (!layanan) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
      <DialogTitle sx={{ pr: 6 }}>
        <MDTypography variant="h5" fontWeight="bold">
          {layanan.nama}
        </MDTypography>
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <MDBox display="flex" flexWrap="wrap" gap={1} mb={2}>
          <Chip label={layanan.sektor} color="info" size="small" />
          <Chip label={layanan.kode} size="small" variant="outlined" />
          <Chip label={layanan.kategori} size="small" variant="outlined" />
        </MDBox>

        <MDBox mb={2}>
          <MDTypography variant="button" color="text">
            Waktu layanan: <strong>{layanan.waktu_layanan || "1 Jam"}</strong>
          </MDTypography>
          <MDTypography variant="button" color="text" display="block">
            Output: <strong>{layanan.output || "Dokumen Izin"}</strong>
          </MDTypography>
        </MDBox>

        {(layanan.perlu_rekomendasi_teknis || layanan.perlu_pemeriksaan_lapangan) && (
          <MDBox display="flex" flexWrap="wrap" gap={1} mb={2}>
            {layanan.perlu_rekomendasi_teknis ? (
              <Chip label="Perlu Rekomendasi Teknis" color="warning" size="small" />
            ) : null}
            {layanan.perlu_pemeriksaan_lapangan ? (
              <Chip label="Perlu Pemeriksaan Lapangan" color="error" size="small" />
            ) : null}
          </MDBox>
        )}

        <MDTypography variant="h6" fontWeight="medium" mb={1}>
          Persyaratan
        </MDTypography>

        {loadingSyarat ? (
          <MDBox display="flex" justifyContent="center" py={3}>
            <CircularProgress size={32} color="info" />
          </MDBox>
        ) : syarat.length === 0 ? (
          <MDTypography variant="body2" color="text">
            Persyaratan belum tersedia.
          </MDTypography>
        ) : (
          <List dense disablePadding>
            {syarat.map((item, index) => (
              <ListItem key={item.id} alignItems="flex-start" sx={{ px: 0 }}>
                <ListItemText
                  primary={`${index + 1}. ${item.nama_syarat}${item.wajib ? " *" : ""}`}
                  secondary={`Jenis: ${item.jenis_input}${item.ekstensi_file ? ` • File: ${item.ekstensi_file}` : ""}`}
                  primaryTypographyProps={{ variant: "body2", fontWeight: "regular" }}
                  secondaryTypographyProps={{ variant: "caption" }}
                />
              </ListItem>
            ))}
          </List>
        )}
        <MDTypography variant="caption" color="text" display="block" mt={1}>
          * Persyaratan wajib
        </MDTypography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <MDButton variant="outlined" color="secondary" onClick={onClose}>
          Tutup
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

ServiceDetailDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  layanan: PropTypes.object,
  syarat: PropTypes.array,
  loadingSyarat: PropTypes.bool,
};

ServiceDetailDialog.defaultProps = {
  layanan: null,
  syarat: [],
  loadingSyarat: false,
};

export default ServiceDetailDialog;
